import React from 'react';
import './style.scss';

export const Button = ({
  type = 'primary',
  className = '',
  children,
  onClick,
  disabled = false,
}) => (
  <button
    type="button"
    className={`QRLinkingButton QRLinkingButton--${type} ${className}`}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
